import classNames from "classnames/bind";
import * as React from "react";
import * as styles from "./ListGroupTitle.less";

interface Props {
    title: string;
    className?: string;
}

const ctx = classNames.bind(styles);

export const ListGroupTitle: React.FC<Props> = props => {
    const { title, className } = props;

    return (
        <div className={ctx(styles.group_row, className)}>
            <span className={styles.group_name} title={title}>
                {title}
            </span>
        </div>
    );
};
